import { atom } from 'jotai';
import { configureAtomDevtools } from '../utils/tracking';

export const selectedPositionIdAtom = configureAtomDevtools(
  atom<string | null>(null),
  'orgchart/selectedPositionId'
);
